var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"accounts"},[_c('UserAccountTable',{attrs:{"headers":_vm.headers,"data":_vm.list}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }